export const Terms = Object.freeze({
  TERMS_OF_USE: 'Terms of Use',
  PRIVACY_POLICY: 'Privacy Policy',
  PROVIDER_AGREEMENT: 'Robyn Provider Agreement',
  HIPAA_AUTHORIZATION: 'HIPAA Authorization',
  NON_COVERED_ENTITY_CERTIFICATION: 'Non-Covered Entity Certification',
  DMCA_COPYRIGHT_POLICY: 'DMCA Copyright Policy',
});
